import { isEmpty, get, extend } from 'lodash';
import axios from 'axios';
import debug from 'debug';
import { enhanceResponseWithEtag, formatPayload } from './helpers.js';
const log = debug('itp:core:connections:core');
const REQUEST_TIMEOUT_MS = 20000;
export function request(url, args) {
    log('request to %o [args: %o]', url, args);
    let content = args ? args.content : undefined, method = args && args.method ? args.method : 'get', headers = args ? headersFor(method, args) : {}, data = content;
    if (!isEmpty(headers)) {
        log('headers: %o', headers);
    }
    if (data && headers && headers['Content-Type']) {
        data = formatPayload(data, headers['Content-Type']);
        log('data: %o', data);
    }
    const extras = {};
    if (args && args.responseType) {
        extras.responseType = args.responseType;
    }
    return ajax({
        method: method,
        url,
        data,
        headers,
        timeout: REQUEST_TIMEOUT_MS,
        ...extras
    });
}
function ajax(config) {
    return axios(config)
        .then(response => {
        response = enhanceResponseWithEtag(response);
        return response;
    });
}
function headersFor(method, args) {
    let result = extend({}, args.headers);
    const content = args.content, params = args.parameters;
    if (content && ['patch', 'delete'].indexOf(method) > -1) {
        const etag = get(content, '$etag') ||
            get(content, 'etag') ||
            (params && (params['$etag'] || params['etag']));
        if (etag) {
            result['If-Match'] = etag;
        }
    }
    if (args.contentType) {
        result['Content-Type'] = args.contentType;
    }
    if (args.language) {
        result['Accept-Language'] = `${args.language},en;q=0.5`;
    }
    return result;
}
//# sourceMappingURL=core.js.map